import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { BrandHeader, Wordmark } from "@/components/runboom/marks";
import { storeSessionToken } from "@/lib/api";

export const Route = createFileRoute("/auth/strava")({
  component: StravaAuthCallback,
});

function StravaAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const session = params.get("session");
    const returnTo = params.get("return_to") || "/me";

    if (session) {
      storeSessionToken(session);
    }

    window.history.replaceState(null, "", "/auth/strava");
    window.location.replace(returnTo.startsWith("/") ? returnTo : "/me");
  }, []);

  return (
    <main className="mx-auto max-w-[1280px] px-4 py-4 sm:px-8 sm:py-10">
      <BrandHeader rightTab="Stadium" />
      <section className="mt-6 rounded-[18px] border border-border bg-bg-elevated p-6 sm:p-10">
        <Wordmark size="sm" />
        <p className="mt-6 font-mono text-[12px] uppercase tracking-[0.1em] text-fg-muted">
          Opening stadium...
        </p>
      </section>
    </main>
  );
}
